import { Button, Dropdown, Menu, Popconfirm, Tabs, notification } from 'antd';
import TableSort from '../../../components/TableSort';
import { useWindowSize } from '../../../hook/useWindowSize';
import { CarOutlined, EllipsisOutlined, UserOutlined, ClearOutlined } from '@ant-design/icons';
import Filter from './Filter';
import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { IMotorista, IVeiculo } from '../../../store/ducks/blackList/types';
import mask, { maskCapitalized } from '../../../utils/mask';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { loadRequest } from '../../../store/ducks/blackList/actions';
import TitlePage from '../../../components/TitlePage';
import TextTable from '../../../components/TextTable';
import { Container, TitleTab } from './styles';
import Refresh from '../../../components/Refresh';
import { alterarBlacklist } from './services/updateBlackList';

interface Props {}

const BlackList: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const { width }: number | any = useWindowSize();
  const [tabKey, setTabKey] = React.useState('1');
  const loading = useSelector((state: ApplicationState) => state.BlackList.loading);
  const filter = useSelector((state: ApplicationState) => state.BlackList.filter);
  const pagination = useSelector((state: ApplicationState) => state.BlackList.pagination);

  const confirm = (record: any, type: string) => {
    try {
      const { codMotorista, codVeiculo } = record;
      alterarBlacklist.alterarBlacklist(true, null, codMotorista, codVeiculo).then((res) => {
        notification.success({
          message: `${type === 'motorista' ? 'Motorista' : 'Veículo'} removido com sucesso!`,
          placement: 'bottomRight',
        });
        dispatch(loadRequest(type));
      });
    } catch (error: any) {
      if (error.response.data.Erro) {
        return notification.error({
          message: error.response.data.Erro,
          placement: 'bottomRight',
        });
      }
      return notification.error({
        message: `Não foi possível remover o ${type}, tente novamente ou contate o suporte.`,
        placement: 'bottomRight',
      });
    }
  };
  const columnsMotoristas: ColumnsType<IMotorista> = [
    {
      title: 'Nome',
      dataIndex: 'nome',
      key: 'nome',
      width: 200,
      fixed: 'left',
      render: (nome: string) => {
        return nome ? <TextTable>{mask('camelCase', nome)}</TextTable> : 'Não informado';
      },
    },

    {
      title: 'CPF',
      dataIndex: 'cpf',
      key: 'cpf',
      width: 200,
      fixed: 'left',
      render: (cpf: string) => {
        return cpf ? <TextTable>{mask('cpfCnpj', cpf)}</TextTable> : 'Não informado';
      },
    },
    {
      title: 'Observação',
      dataIndex: 'obs',
      key: 'obs',
      width: 200,
      fixed: 'left',
      render: (obs: string) => {
        return obs ? <TextTable>{maskCapitalized(obs)}</TextTable> : 'Sem observação';
      },
    },

    {
      title: 'Ação',
      dataIndex: 'acao',
      key: 'acao',
      width: 50,
      fixed: 'right',
      align: 'center',
      render: (text: any, record: any) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item className="themeOrdemCargaAcao">
              <Popconfirm
                title={
                  <>
                    Tem certeza que deseja remover esse motorista da <i>block list</i>
                  </>
                }
                onConfirm={() => confirm(record, 'motorista')}
                okText="Sim"
                cancelText="Não"
              >
                <Button icon={<ClearOutlined />}>
                  Remover da <i> block list</i>
                </Button>
              </Popconfirm>
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button type="text" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];
  const dataSourceMotoristas = useSelector(
    (state: ApplicationState) => state.BlackList.data['motorista']
  );
  const columnsVeiculos: ColumnsType<IVeiculo> = [
    {
      title: 'Placa',
      dataIndex: 'placa',
      key: 'placa',
      width: 200,
      fixed: 'left',
      render: (placa: string) => {
        return placa ? <TextTable>{placa?.toUpperCase()}</TextTable> : 'Não informado';
      },
    },
    {
      title: 'Observação',
      dataIndex: 'obs',
      key: 'obs',
      width: 200,
      fixed: 'left',
      render: (obs: string) => {
        return obs ? <TextTable>{maskCapitalized(obs)}</TextTable> : 'Sem observação';
      },
    },
    {
      title: 'Ação',
      dataIndex: 'acao',
      key: 'acao',
      width: 50,
      fixed: 'right',
      align: 'center',

      render: (text: any, record: any) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item className="themeOrdemCargaAcao">
              <Popconfirm
                title={
                  <>
                    Tem certeza que deseja remover esse veículo da <i>block list</i>
                  </>
                }
                onConfirm={() => confirm(record, 'veiculo')}
                okText="Sim"
                cancelText="Não"
              >
                <Button icon={<ClearOutlined />}>
                  Remover da <i> block list</i>
                </Button>
              </Popconfirm>
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button type="text" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];
  const dataSourceVeiculos = useSelector(
    (state: ApplicationState) => state.BlackList.data['veiculos']
  );

  return (
    <>
      <Filter tabeKey={tabKey} />
      <Refresh
        loadRequest={() => dispatch(loadRequest(tabKey === '1' ? 'motorista' : 'veiculo'))}
      />
      {width > 768 && (
        <Container>
          <TitlePage>
            <span className="titleGrid">
              <i>Block List</i>
            </span>
          </TitlePage>

          <Tabs defaultActiveKey="1">
            <Tabs.TabPane
              tab={
                <TitleTab>
                  <Button icon={<UserOutlined />} type="text" onClick={() => setTabKey('1')}>
                    Motoristas
                  </Button>
                </TitleTab>
              }
              key="1"
            >
              <TableSort
                scroll={{ x: 1200 }}
                style={{ fontSize: 10, display: 'inline' }}
                columns={columnsMotoristas}
                size={'large'}
                onChange={(pagination: any, filters: any, sorter: any) => {
                  dispatch(loadRequest('motorista', filter, pagination));
                }}
                pagination={pagination}
                className="table"
                dataSource={dataSourceMotoristas}
                loading={loading}
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              tab={
                <TitleTab>
                  <Button icon={<CarOutlined />} type="text" onClick={() => setTabKey('2')}>
                    Veículos
                  </Button>
                </TitleTab>
              }
              key="2"
            >
              <TableSort
                scroll={{ x: 1200 }}
                style={{ fontSize: 10, display: 'inline' }}
                columns={columnsVeiculos}
                size={'large'}
                onChange={(pagination: any, filters: any, sorter: any) => {
                  dispatch(loadRequest('veiculo', filter, pagination));
                }}
                pagination={pagination}
                className="table"
                dataSource={dataSourceVeiculos}
                loading={loading}
              />
            </Tabs.TabPane>
          </Tabs>
        </Container>
      )}
    </>
  );
};
export default BlackList;
